import React from "react";
import { Loader2 } from "lucide-react";
import "../styling/loadingmask.css";

const LoadingMask = ({ message = "Please wait..." }) => {
  return (
    <div className="loading-backdrop">
      <div className="loading-pill">
        <Loader2 className="loading-spinner" />
        <span className="loading-text">{message}</span>
      </div>
    </div>
  );
};

export default LoadingMask;
